const defaultFilters = ["jobs", "trainings", "duo"]

export { defaultFilters }
